<template>
  <div id="returnOrderAdd">
    <!-- <van-nav-bar title="退租中" fixed placeholder left-arrow>
            <a @click="$router.back()" slot="left">
                <i class="iconfont iconfanhuianniu"></i>
            </a>
            <span style="color:#FD7E2D" slot="right" v-if="active ===0" @click="next1">下一步</span>
            <span style="color:#FD7E2D" slot="right" v-else-if="active ===1" @click="next2">下一步</span>
            <span style="color:#FD7E2D" slot="right" v-else-if="active === 2" @click="next3">保存</span>
        </van-nav-bar> -->
    <van-steps
      class="step"
      @click-step="
        (item) => {
          if (activeMax > item || activeMax == item) {
            active = item;
          }
        }
      "
      :active="active"
      active-color="#FD7E2D"
    >
      <van-step>资产盘点</van-step>
      <van-step>退租信息</van-step>
      <van-step>退租事项</van-step>
    </van-steps>
    <div v-if="active === 0" class="form1">
      <div v-for="item in assetsData || []" :key="item.no">
        <div class="title">
          <i class="iconfont iconbookmark"></i>
          {{ item.no === "Pub" ? "公区" : item.no }}&ensp;
        </div>
        <div class="assetsBody">
          <div
            v-for="assets in item.assets || []"
            :key="assets.assetsId"
            @click="lookAssets(assets)"
          >
            {{ assets.materialTypeName }}
          </div>
        </div>
      </div>
      <van-empty v-if="!(assetsData || []).length" description="暂无数据" />
      <div style="height: 1.2rem"></div>
      <div class="btn">
        <van-button type="primary" @click="next1">下一步</van-button>
      </div>
    </div>
    <div v-if="active === 1" class="form2">
      <van-form ref="form2" label-width="110px" input-align="right">
        <van-field
          readonly
          clickable
          required
          :disabled="quitTypeD"
          name="quitType"
          :value="
            form.quitType
              ? quitTypeList.find((d) => {
                  return d.value == form.quitType;
                }).label
              : ''
          "
          label="退租类型"
          placeholder="点击选择>"
          @click="
            (item) => {
              if (!quitTypeD) {
                showQuitType = true;
              }
            }
          "
          :rules="[{ required: true, message: '请选择退租类型' }]"
        />
        <van-field
          readonly
          clickable
          required
          :disabled="Boolean(quitDateD || !form.quitType)"
          name="quitDate"
          :value="form.quitDate ? form.quitDate.slice(0, 10) : ''"
          label="退租日期"
          placeholder="点击选择日期>"
          @click="
            (item) => {
              if (!(quitDateD || !form.quitType)) {
                showQuitDate = true;
              }
            }
          "
          :rules="[{ required: true, message: '请选择日期' }]"
        />
        <van-field
          readonly
          clickable
          name="receiptId"
          :value="
            form.receiptId
              ? accountList.find((d) => d.id == form.receiptId).text
              : ''
          "
          label="收款账号"
          placeholder="点击选择>"
          @click="
            (item) => {
              showAccount = true;
            }
          "
        />
        <!-- <van-field readonly clickable required name="payType" :value="payTypeList[this.form.payType-1]" label="支付方式" placeholder="点击选择>" @click="showPayType = true" :rules="[{ required: true, message: '请选择支付方式' }]" />
                <van-field v-if="form.payType" required disabled name="bankAccount" :value="form.bankAccount" label="收款账号" placeholder="点击搜索>" @click="showCustomer = true;searchValueCustomer='';customerList=[]" maxlength="11" :rules="[{ required: true, message: '请填写收款账号' }]" />
                <van-field v-if="form.payType" required v-model="form.accountName" name="accountName" label="收款人姓名" placeholder="点击填写" :rules="[{ required: true, message: '请填写姓名' }]" />
                <van-field v-if="form.payType == 3 || form.payType == 4" required v-model="form.bankName" name="name" label="收款银行名称" placeholder="点击填写" :rules="[{ required: true, message: '请填写银行名称' }]" /> -->
        <van-field
          v-model="form.othersRemark"
          rows="2"
          autosize
          label="备注"
          type="textarea"
          placeholder="请输入备注"
        />
        <div class="body">
          <div class="picCard">
            <div class="text">电峰</div>
            <van-uploader
              v-if="!existEle"
              :before-read="beforeRead"
              :after-read="
                (item) => {
                  electricMaxUrl = [
                    {
                      url: upload_qiniu_addr + item.file.key,
                      isImage: true,
                    },
                  ];
                  $refs.form2.resetValidation('electricMaxUrl');
                }
              "
              v-model="electricMaxUrl"
              multiple
              :max-count="1"
            />
            <div class="text textBorder" v-if="!existEle">
              <van-field
                type="number"
                name="electricMaxUrl"
                maxlength="11"
                v-model="form.electricMax"
                @input="
                  form.electricTotal = accAdd(
                    form.electricMin,
                    form.electricMax
                  )
                "
                border
                :placeholder="'当前:' + houseDegrees.lastElectricMax"
                :rules="[
                  {
                    validator: (item) => {
                      return Boolean(electricMaxUrl.length) || !imgUp;
                    },
                    message: '请上传电峰图',
                  },
                  { required: true, message: '请请输入电峰' },
                  {
                    validator: validNum0Decimal2,
                    message: '电峰必须为正数或0，且最多保留两位小数',
                  },
                ]"
              />
            </div>
          </div>
          <div class="picCard">
            <div class="text">电谷</div>
            <van-uploader
              v-if="!existEle"
              :before-read="beforeRead"
              :after-read="
                (item) => {
                  electricMinUrl = [
                    {
                      url: upload_qiniu_addr + item.file.key,
                      isImage: true,
                    },
                  ];
                  $refs.form2.resetValidation('electricMinUrl');
                }
              "
              v-model="electricMinUrl"
              multiple
              :max-count="1"
            />
            <div class="text textBorder" v-if="!existEle">
              <van-field
                type="number"
                name="electricMinUrl"
                maxlength="11"
                v-model="form.electricMin"
                @input="
                  form.electricTotal = accAdd(
                    form.electricMin,
                    form.electricMax
                  )
                "
                :placeholder="'当前:' + houseDegrees.lastElectricMin"
                :rules="[
                  {
                    validator: (item) => {
                      return Boolean(electricMinUrl.length) || !imgUp;
                    },
                    message: '请上传电谷图',
                  },
                  { required: true, message: '请输入电谷' },
                  {
                    validator: validNum0Decimal2,
                    message: '电谷必须为正数或0，且最多保留两位小数',
                  },
                ]"
              />
            </div>
          </div>
          <div class="picCard">
            <div class="text">电总</div>
            <van-uploader
              v-if="!existEle"
              :before-read="beforeRead"
              :after-read="
                (item) => {
                  electricTotalUrl = [
                    {
                      url: upload_qiniu_addr + item.file.key,
                      isImage: true,
                    },
                  ];
                  $refs.form2.resetValidation('electricTotalUrl');
                }
              "
              v-model="electricTotalUrl"
              multiple
              :max-count="1"
            />
            <div class="text textBorder" v-if="!existEle">
              <van-field
                v-if="!existEle"
                type="number"
                name="electricTotalUrl"
                maxlength="11"
                v-model="form.electricTotal"
                :placeholder="'当前:' + houseDegrees.lastElectricTotal"
                :rules="[
                  {
                    validator: (item) => {
                      return Boolean(electricTotalUrl.length) || !imgUp;
                    },
                    message: '请上传电总图',
                  },
                  { required: true, message: '请输入电总' },
                  {
                    validator: validNum0Decimal2,
                    message: '电总必须为正数或0，且最多保留两位小数',
                  },
                ]"
              />
            </div>
          </div>
        </div>
        <div v-if="existEle" class="box">
          提示：该房源已安装智能电表，无需上传图片及度数
        </div>
        <div class="body">
          <div class="picCard">
            <div class="text">水度数</div>
            <van-uploader
              v-if="!existWater"
              :before-read="beforeRead"
              :after-read="
                (item) => {
                  waterUrl = [
                    {
                      url: upload_qiniu_addr + item.file.key,
                      isImage: true,
                    },
                  ];
                  $refs.form2.resetValidation('waterUrl');
                }
              "
              v-model="waterUrl"
              multiple
              :max-count="1"
            />
            <div class="text textBorder" v-if="!existWater">
              <van-field
                type="number"
                name="waterUrl"
                maxlength="11"
                v-model="form.water"
                :placeholder="'当前:' + houseDegrees.lastWater"
                :rules="[
                  {
                    validator: (item) => {
                      return Boolean(waterUrl.length) || !imgUp;
                    },
                    message: '请上传水图',
                  },
                  { required: true, message: '请输入水度数' },
                  {
                    validator: validNum0Decimal2,
                    message: '水度数必须为正数或0，且最多保留两位小数',
                  },
                ]"
              />
            </div>
          </div>
        </div>
        <div v-if="existWater" class="box">
          提示：该房源已安装智能水表，无需上传图片及度数
        </div>
        <div class="body">
          <div class="picCard textBorder">
            <div class="text">燃气度数</div>
            <van-uploader
              :before-read="beforeRead"
              :after-read="
                (item) => {
                  gasUrl = [
                    {
                      url: upload_qiniu_addr + item.file.key,
                      isImage: true,
                    },
                  ];
                  $refs.form2.resetValidation('gasUrl');
                }
              "
              v-model="gasUrl"
              multiple
              :max-count="1"
            />
            <div class="text textBorder">
              <van-field
                type="number"
                name="gasUrl"
                maxlength="11"
                v-model="form.gas"
                :placeholder="'当前:' + houseDegrees.lastGas"
                :rules="[
                  {
                    validator: (item) => {
                      return Boolean(gasUrl.length) || !imgUp;
                    },
                    message: '请上传燃气图',
                  },
                  { required: true, message: '请输入燃气度数' },
                  {
                    validator: validNum0Decimal2,
                    message: '燃气度数必须为正数或0，且最多保留两位小数',
                  },
                ]"
              />
            </div>
          </div>
        </div>
        <div class="field">其它（最多上传9张）</div>
        <div class="body body1">
          <van-uploader
            :before-read="beforeRead"
            :after-read="
              (item) => {
                otherList.pop();
                otherList.push({
                  url: upload_qiniu_addr + item.file.key,
                  isImage: true,
                });
              }
            "
            v-model="otherList"
            :max-count="9"
          />
        </div>
      </van-form>
      <div style="height: 1.2rem"></div>
      <div class="btn">
        <van-button type="primary" @click="next2">下一步</van-button>
      </div>
    </div>
    <div v-if="active === 2" class="form3">
      <div class="card">
        <div class="title">
          应收事项
          <span class="icon">
            <van-button
              size="mini"
              type="primary"
              @click="
                orderType = 1;
                showOrder = true;
                getMatter();
              "
              >添加</van-button
            >
          </span>
        </div>
        <table class="table">
          <tr class="head">
            <td>费用类型</td>
            <td>金额</td>
            <td>生成方式</td>
            <td>
              <span>操作</span>
            </td>
          </tr>
          <tr
            v-for="(item, index) in form.receivableOrderItems || []"
            :key="item.matterId"
          >
            <td>{{ item.matterName }}</td>
            <td>{{ item.amount }}</td>
            <td>{{ item.readOnly ? "系统" : "手动" }}</td>
            <td>
              <span
                style="color: #fd7e2d"
                @click="$dialog.alert({ message: item.remark })"
                >查看</span
              >&emsp;
              <span
                v-if="!item.readOnly && !item.orderItemId"
                style="color: #fd7e2d"
                @click="form.receivableOrderItems.splice(index, 1)"
                >删除</span
              >
            </td>
          </tr>
          <tr>
            <td>应收合计</td>
            <td>{{ receivableAll }}元</td>
            <td></td>
            <td></td>
          </tr>
        </table>
      </div>
      <div class="card">
        <div class="title">
          应付事项
          <span class="icon">
            <van-button
              size="mini"
              type="primary"
              @click="
                orderType = 0;
                showOrder = true;
                getMatter();
              "
              >添加</van-button
            >
          </span>
        </div>
        <table class="table">
          <tr class="head">
            <td>费用类型</td>
            <td>金额</td>
            <td>生成方式</td>
            <td>
              <span>操作</span>
            </td>
          </tr>
          <tr
            v-for="(item, index) in form.payableOrderItems || []"
            :key="item.matterId"
          >
            <td>{{ item.matterName }}</td>
            <td>{{ item.amount }}</td>
            <td>{{ item.readOnly ? "系统" : "手动" }}</td>
            <td>
              <span
                style="color: #fd7e2d"
                @click="$dialog.alert({ message: item.remark })"
                >查看</span
              >&emsp;
              <span
                v-if="!item.readOnly && !item.orderItemId"
                style="color: #fd7e2d"
                @click="form.payableOrderItems.splice(index, 1)"
                >删除</span
              >
            </td>
          </tr>
          <tr>
            <td>应付合计</td>
            <td>{{ payableAll }}元</td>
            <td></td>
            <td></td>
          </tr>
        </table>
      </div>
      <div class="card">
        <div class="title" v-if="payableAll - receivableAll > 0">
          应付：{{ payableAll }} - {{ receivableAll }} =
          {{ accSub(payableAll, receivableAll) }}
        </div>
        <div class="title" v-else>
          应收：{{ receivableAll }} - {{ payableAll }} =
          {{ accSub(receivableAll, payableAll) }}
        </div>
      </div>
      <div class="card">
        <div class="title">
          所有账单
          <span class="icon" @click="orderI = !orderI">
            <i
              class="iconfont"
              :class="orderI ? 'iconjian' : 'icontianjia'"
            ></i>
          </span>
        </div>
        <div v-show="orderI">
          <div
            class="orderBody"
            v-for="(orderItems, index) in contract.contractOrderList || []"
            :key="index"
          >
            <div>
              <div class="orderBody-body blod">
                <div class="name">{{ orderItems.orderName }}</div>
                <div :class="orderItems.status == '3' ? 'success' : 'fail'">
                  {{
                    orderItems.status == "1"
                      ? "未支付"
                      : orderItems.status == "2"
                      ? "部分支付"
                      : orderItems.status == "3"
                      ? "已支付"
                      : ""
                  }}
                </div>
              </div>
              <div class="orderBody-body">
                租期：{{
                  orderItems.startDate ? orderItems.startDate.slice(0, 10) : ""
                }}
                到
                {{ orderItems.endDate ? orderItems.endDate.slice(0, 10) : "" }}
              </div>
              <div class="orderBody-head">
                <div>
                  <p class="name">账单金额</p>
                  <p class="text">￥{{ orderItems.copeAmount }}</p>
                </div>
                <div class="line"></div>
                <div>
                  <p class="name">已付金额</p>
                  <p class="text">￥{{ orderItems.actualAmount }}</p>
                </div>
                <div class="line"></div>
                <div>
                  <p class="name">账单日期</p>
                  <p class="text">
                    {{
                      orderItems.expireDate
                        ? orderItems.expireDate.slice(0, 10)
                        : ""
                    }}
                  </p>
                </div>
              </div>
              <div
                :class="orderItems.detailShow ? '' : 'border-b'"
                class="orderBody-body"
              >
                <div class="name">
                  <!-- <span v-if="orderItems.unpaidAmount/1<0">待收款金额</span> -->
                  <span>未支付金额</span>&emsp;
                  <span class="money"
                    >￥{{
                      accSub(orderItems.copeAmount, orderItems.actualAmount)
                    }}</span
                  >
                </div>
                <div
                  class="text"
                  @click.stop="orderItems.detailShow = !orderItems.detailShow"
                >
                  费用明细
                  <span>
                    <i
                      v-if="!orderItems.detailShow"
                      class="iconfont iconxiala"
                    ></i>
                    <i
                      v-if="orderItems.detailShow"
                      class="iconfont iconxiangshang"
                    ></i>
                  </span>
                </div>
              </div>
              <div class="details" v-if="orderItems.detailShow">
                <div
                  v-for="(detail, index) in orderItems.orderItemList || []"
                  :key="index"
                >
                  <div class="name">{{ detail.matterName }}</div>
                  <div>￥{{ detail.copeAmount }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card" v-if="(contract.wegOrders || []).length">
        <van-tabs value="1">
          <van-tab title="水电燃账单">
            <div
              v-for="(orderItems, index) in contract.wegOrders || []"
              :key="index"
            >
              <div class="orderBody">
                <div class="orderBody-body blod">
                  <div class="name">{{ orderItems.orderName }}</div>
                  <div :class="orderItems.status == '3' ? 'success' : 'fail'">
                    {{
                      orderItems.status == "1"
                        ? "未支付"
                        : orderItems.status == "2"
                        ? "部分支付"
                        : orderItems.status == "3"
                        ? "已支付"
                        : ""
                    }}
                  </div>
                </div>
                <div class="orderBody-body">
                  租期：{{
                    orderItems.startDate
                      ? orderItems.startDate.slice(0, 10)
                      : ""
                  }}
                  到
                  {{
                    orderItems.endDate ? orderItems.endDate.slice(0, 10) : ""
                  }}
                </div>
                <div class="orderBody-head">
                  <div>
                    <p class="name">账单金额</p>
                    <p class="text">￥{{ orderItems.copeAmount }}</p>
                  </div>
                  <div class="line"></div>
                  <div>
                    <p class="name">已付金额</p>
                    <p class="text">￥{{ orderItems.actualAmount }}</p>
                  </div>
                  <div class="line"></div>
                  <div>
                    <p class="name">账单日期</p>
                    <p class="text">
                      {{
                        orderItems.expireDate
                          ? orderItems.expireDate.slice(0, 10)
                          : ""
                      }}
                    </p>
                  </div>
                </div>
                <div
                  :class="orderItems.detailShow ? '' : 'border-b'"
                  class="orderBody-body"
                >
                  <div class="name">
                    <!-- <span v-if="orderItems.unpaidAmount/1<0">待收款金额</span> -->
                    <span>未支付金额</span>&emsp;
                    <span class="money"
                      >￥{{
                        accSub(orderItems.copeAmount, orderItems.actualAmount)
                      }}</span
                    >
                  </div>
                  <div
                    class="text"
                    @click.stop="orderItems.detailShow = !orderItems.detailShow"
                  >
                    费用明细
                    <span>
                      <i
                        v-if="!orderItems.detailShow"
                        class="iconfont iconxiala"
                      ></i>
                      <i
                        v-if="orderItems.detailShow"
                        class="iconfont iconxiangshang"
                      ></i>
                    </span>
                  </div>
                </div>
                <div class="details" v-if="orderItems.detailShow">
                  <div
                    v-for="(detail, index) in orderItems.orderItemList || []"
                    :key="index"
                  >
                    <div class="name">{{ detail.matterName }}</div>
                    <div>￥{{ detail.copeAmount }}</div>
                  </div>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
      <div style="height: 1.2rem"></div>
      <div class="btn">
        <van-button
          type="primary"
          :loading="saveLoad"
          :disabled="saveLoad"
          @click="next3"
          >保存</van-button
        >
      </div>
    </div>
    <!-- <div class="btn" v-if="active == 2 && (form.returnOrderStatus == 3 || form.returnOrderStatus == 1 || !form.returnOrderStatus)">
            <van-button type="primary" @click="orderType = 1;showOrder = true">添加应收</van-button>
            <van-button type="primary" @click="orderType = 0;showOrder = true">添加应付</van-button>
        </div> -->
    <!-- 退租类型 -->
    <van-popup v-model="showQuitType" position="bottom">
      <van-picker
        show-toolbar
        :columns="quitTypeList"
        value-key="label"
        @confirm="quitTypeConfirm"
        @cancel="showQuitType = false"
      />
    </van-popup>
    <!-- 退租日期 -->
    <van-popup v-model="showQuitDate" position="bottom">
      <van-datetime-picker
        type="date"
        v-model="currentDate"
        @confirm="
          (item) => {
            form.quitDate = formatDate(item) + ' 00:00:00';
            showQuitDate = false;
          }
        "
        @cancel="showQuitDate = false"
        :min-date="startRangeDate"
        :max-date="endRangeDate"
      />
    </van-popup>
    <!-- 收款账号 -->
    <van-popup v-model="showAccount" position="bottom">
      <van-picker
        show-toolbar
        :columns="accountList"
        @confirm="
          (item, index) => {
            form.receiptId = item.id;
            showAccount = false;
            $refs.form2.resetValidation('receiptId');
          }
        "
        @cancel="showAccount = false"
      />
    </van-popup>
    <!-- 支付方式 -->
    <!-- <van-popup v-model="showPayType" position="bottom">
            <van-picker show-toolbar :columns="payTypeList" @confirm="(item,index) => { form.payType = index/1+1;showPayType=false;$refs.form2.resetValidation('payType')}" @cancel="showPayType = false" />
        </van-popup> -->

    <!-- 账号搜索 -->
    <!-- <transition name="van-slide-right">
            <div v-if="showCustomer" class="search">
                <form action="/">
                    <van-search v-model="searchValueCustomer" shape="round" show-action placeholder="请输入手机号搜索" @input="onSearchCustomer" @search="onSearchCustomer">
                        <template #action>
                            <div @click="onConfirm" v-if="searchValueCustomer">确定</div>
                            <div @click="showCustomer = false" v-else>取消</div>
                        </template>
                    </van-search>
                </form>
                <van-cell v-for="customer in (customerList||[])" :key="customer.id" :title="form.payType == '1' || form.payType == '2' ? customer.accountName + '-' + customer.bankAccount : customer.accountName + '-' + customer.bankName + '（' + customer.bankAccount + '）'" icon="user-o" @click="changeCustomer(customer)"></van-cell>
                <van-loading v-if="searchLoad" size="24" />
                <div v-else-if="searchValueCustomer&&!customerList.length">暂无数据</div>
            </div>
        </transition> -->
    <!-- 资产详情 -->
    <van-dialog
      v-model="showAssets"
      title="资产详情"
      show-cancel-button
      :showConfirmButton="false"
      :showCancelButton="false"
      :closeOnClickOverlay="true"
      width="300"
    >
      <van-cell title="名称" :value="asstesDetail.materialTypeName" />
      <van-cell title="品类" :value="asstesDetail.materialTypeParentName" />
      <van-cell title="规格" :value="asstesDetail.specification" />
      <van-cell title="品牌" :value="asstesDetail.brand" />
      <van-cell title="型号" :value="asstesDetail.model" />
    </van-dialog>
    <!-- 应收应付弹框 -->
    <van-dialog
      v-model="showOrder"
      :title="orderType ? '应收' : '应付'"
      show-cancel-button
      :before-close="orderConfirm"
    >
      <van-form ref="orderItem" input-align="right">
        <van-field
          required
          readonly
          clickable
          name="matterName"
          :value="matter.matterName"
          label="事项"
          placeholder="选择事项"
          @click="showMatter = true"
          :rules="[{ required: true, message: '请选择事项' }]"
        />
        <van-field
          required
          v-model="matter.amount"
          type="number"
          name="amount"
          label="金额"
          placeholder="点击填写"
          :rules="[
            { required: true, message: '请填写金额' },
            {
              validator: validNum0Decimal2,
              message: '金额必须大于0且最多保留两位小数',
            },
          ]"
        />
        <van-field
          required
          v-model="matter.remark"
          type="textarea"
          name="remark"
          label="备注"
          placeholder="请填写备注"
          rows="2"
          maxlength="50"
          autosize
          :rules="[{ required: true, message: '请填写备注' }]"
        />
      </van-form>
    </van-dialog>
    <!-- 事项下拉 -->
    <van-popup v-model="showMatter" position="bottom">
      <van-picker
        show-toolbar
        :columns="matterList"
        value-key="name"
        @confirm="
          (item) => {
            matter.matterName = item.name;
            matter.matterId = item.id;
            showMatter = false;
            $refs.orderItem.resetValidation('matterName');
          }
        "
        @cancel="showMatter = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  validPhone,
  validEmail,
  validIdNo,
  validNum0Decimal2,
} from "@/utils/validate";

import {
  requestContractDetailReturn,
  requestReceiptList,
  requestQiniuToken,
  requestOrderItems,
  requestMatter,
  requestExpensesReturnP,
  requestExpensesReturnR,
  requestReturnAdd,
  requestCReturnDetail,
  requestAccountSelect,
} from "@/api";
import { formatDate, getEndDate, getNdaysDate } from "@/utils/index";
import { compress, compressAccurately } from "image-conversion";
import request from "@/utils/request";
import { imgUp } from "@/common/js/constant.js";
import { mergeRowCol, accAdd, accSub } from "@/utils/index";
export default {
  name: "returnOrderAdd",
  data() {
    return {
      imgUp: imgUp,
      active: 0,
      activeMax: 0, //用户已经走到那一步（之前的步骤可以随意跳转）
      contract: {
        wegOrders: [],
      },
      form: {
        contractId: "", //合约id
        receiptId: "", //收款人id
        // payType: "", //支付方式
        // bankAccount: "", //收款账号
        // accountName: "", //收款人姓名
        // bankName: "", //银行名称
        quitDate: "", //退租日期
        quitType: "", //退租类型
        electricTotalUrl: "", //电总图
        electricMaxUrl: "", //电峰图
        electricMinUrl: "", //电谷图
        electricTotal: "", //电总
        electricMax: "", //电峰
        electricMin: "", //电谷
        waterUrl: "", //水图
        water: "", //水
        gasUrl: "", //燃气图
        gas: "", //燃气
        receivableOrderItems: [],
        payableOrderItems: [],
        othersRemark: "",
        othersUrl: "",
      },
      qiniuData: {
        key: "",
        token: "",
      },
      existEle: "",
      existWater: "",
      quitTypeD: false,
      quitDateD: false,
      //第一步
      assetsData: [],
      asstesDetail: {},
      showAssets: false,
      //第二步
      houseDegrees: {}, //当前房源水电燃度数
      quitTypeList: [],
      accountList: [],
      showQuitType: false,
      showQuitDate: false,
      showAccount: false,
      showPayType: false,
      currentDate: new Date(),
      startRangeDate: new Date(),
      endRangeDate: new Date(2030, 0, 1),
      createTime: "", //退租单创建时间
      timeBefore3: "", //创建时间3天前时间
      timeAfter3: "", //创建时间3天后时间
      showCustomer: false,
      customerNow: {},
      searchValueCustomer: "",
      customerList: [], //搜索客户
      searchLoad: false,
      electricTotalUrl: [], //电总
      electricMaxUrl: [], //电峰
      electricMinUrl: [], //电谷
      waterUrl: [], //水
      gasUrl: [], //燃气
      otherList: [],
      //第三步
      receivableAll: 0, //应收合计
      payableAll: 0, //应付合计
      receivIds: [], //系统应收事项id
      payIds: [], //系统应付事项id
      showOrder: false,
      showMatter: false,
      matter: {
        matterId: "",
        matterName: "",
        amount: "",
        readOnly: 0,
        remark: "",
      },
      matterList: [],
      orderType: 1,
      orderI: true, //所有账单默认展开
      saveLoad: false,
    };
  },
  computed: {
    ...mapState([
      "idTypeList",
      "destineList",
      "payList",
      "contractList",
      "payTypeList",
      "upload_qiniu_addr",
    ]),
  },
  created() {
    //新增
    if (this.$route.query.contractId) {
      this.getContract(this.$route.query.contractId);
    }
    //修改
    if (this.$route.query.id) {
      this.getReturn(this.$route.query.id);
      this.activeMax = 2;
    }

    this.getQiniuToken();
  },
  mounted() {},
  watch: {
    "form.receivableOrderItems": {
      handler(newData, oldData) {
        let all = 0;
        newData.forEach((d) => {
          all = accAdd(all, d.amount / 1);
        });
        this.receivableAll = all;
      },
      deep: true,
    },
    "form.payableOrderItems": {
      handler(newData, oldData) {
        let all = 0;
        newData.forEach((d) => {
          all = accAdd(all, d.amount / 1);
        });
        this.payableAll = all;
      },
      deep: true,
    },
    active(nowData) {
      this.activeMax = nowData > this.activeMax ? nowData : this.activeMax;
      switch (nowData) {
        case 1:
          break;
        case 2:
          // this.getMatter();
          break;

        default:
          break;
      }
    },
  },
  methods: {
    //获取合约数据
    getContract(contractId) {
      return requestContractDetailReturn(contractId)
        .then((res) => {
          this.assetsData = res.data.contractAssetsVOList
            ? res.data.contractAssetsVOList
            : [];
          res.data.wegOrders = res.data.wegOrders || [];
          res.data.contractOrderList.forEach((d) => {
            d.detailShow = false;
          });
          this.contract = res.data;
          this.existEle = res.data.existEle;
          this.existWater = res.data.existWater;
          this.form.contractId = res.data.contractId;
          this.form.customerId = res.data.customerId;
          this.form.receiptId = res.data.receiptId;
          const endDate30 = getNdaysDate(res.data.endDate, -30);
          const endDate = res.data.endDate;
          const nowDate = formatDate(new Date());
          if (nowDate < endDate30) {
            this.quitTypeList = [
              {
                label: "租客违约退租",
                value: 2,
              },
              {
                label: "公司违约退",
                value: 4,
              },
              {
                label: "协商违约退",
                value: 6,
              },
            ];
          } else if (
            (endDate30 < nowDate || endDate30 == nowDate) &&
            nowDate < endDate
          ) {
            this.quitTypeList = [
              {
                label: "租客违约退租",
                value: 2,
              },
              {
                label: "正常提前退租",
                value: 3,
              },
              {
                label: "公司违约退",
                value: 4,
              },
              {
                label: "协商违约退",
                value: 6,
              },
            ];
          } else {
            this.quitTypeList = [
              {
                label: "到期退租",
                value: 1,
              },
            ];
          }
          this.createTime = new Date(formatDate(new Date()).replace(/-/g, "/"));
          this.timeBefore3 = getNdaysDate(new Date(), -3);
          this.timeAfter3 = getNdaysDate(new Date(), 3);
          this.getAccount(this.contract.customerId);
          //水电燃度数
          this.houseDegrees = {
            lastElectricMax: res.data.lastElectricMax / 1,
            lastElectricMin: res.data.lastElectricMin / 1,
            lastElectricTotal: res.data.lastElectricTotal / 1,
            lastGas: res.data.lastGas / 1,
            lastWater: res.data.lastWater / 1,
          };
          return res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取退租单数据
    getReturn(id) {
      return requestCReturnDetail(id)
        .then((res) => {
          //退租事项下拉
          if (
            res.data.quitType == 7 ||
            res.data.quitType == 8 ||
            res.data.quitType == 9
          ) {
            this.quitTypeD = true;
            this.quitDateD = true;
            this.quitTypeList = [
              {
                label: "到期退租",
                value: 1,
              },
              {
                label: "租客违约退租",
                value: 2,
              },
              {
                label: "正常提前退租",
                value: 3,
              },
              {
                label: "公司违约退",
                value: 4,
              },
              // {
              //   label:"房东违约退",
              //   value:5
              // },
              {
                label: "协商违约退",
                value: 6,
              },
              {
                label: "续约退租",
                value: 7,
              },
              {
                label: "换房退租",
                value: 8,
              },
              {
                label: "转租退租",
                value: 9,
              },
            ];
          } else {
            if (res.data.returnOrderStatus == 3) this.quitTypeD = true;
            const endDate30 = getNdaysDate(res.data.endDate, -30);
            const endDate = res.data.endDate;
            const nowDate = res.data.createDate;
            if (nowDate < endDate30) {
              this.quitTypeList = [
                {
                  label: "租客违约退租",
                  value: 2,
                },
                {
                  label: "公司违约退",
                  value: 4,
                },
                {
                  label: "协商违约退",
                  value: 6,
                },
              ];
            } else if (
              (endDate30 < nowDate || endDate30 == nowDate) &&
              nowDate < endDate
            ) {
              this.quitTypeList = [
                {
                  label: "租客违约退租",
                  value: 2,
                },
                {
                  label: "正常提前退租",
                  value: 3,
                },
                {
                  label: "公司违约退",
                  value: 4,
                },
                {
                  label: "协商违约退",
                  value: 6,
                },
              ];
            } else {
              this.quitTypeList = [
                {
                  label: "到期退租",
                  value: 1,
                },
              ];
            }
          }
          if (res.data.quitType == 8) {
            this.quitDateD = false;
            this.startRangeDate = new Date(
              getNdaysDate(
                res.data.nextContractStartDate.replace(/-/g, "/"),
                -1
              )
            );
            this.endRangeDate = new Date(
              res.data.nextContractEndDate.replace(/-/g, "/")
            );
          }
          //时间
          this.createTime = new Date(res.data.createDate.replace(/-/g, "/"));
          this.timeBefore3 = getNdaysDate(res.data.createDate, -3);
          this.timeAfter3 = getNdaysDate(res.data.createDate, 3);

          //资产
          this.assetsData = res.data.contractAssetsVOList;
          // let assets = [];
          // if (res.data.contractAssetsVOList) {
          //   res.data.contractAssetsVOList.forEach(d => {
          //     let first = true;
          //     d.assets.forEach(e => {
          //       e.rowspan = first ? d.assets.length : 0;
          //       assets.push(e);
          //       first = false;
          //     });
          //   });
          // }
          // res.data.assets = assets;
          // res.data.orderList = mergeRowCol(res.data.orderList, "orderNumber");
          //事项
          if (res.data.receivableOrderItems) {
            res.data.receivableOrderItems.forEach((d) => {
              this.receivIds.push(d.matterId);
            });
          }
          if (res.data.payableOrderItems) {
            res.data.payableOrderItems.forEach((d) => {
              this.payIds.push(d.matterId);
            });
          }
          //账单
          res.data.contractOrderList.forEach((d) => {
            d.detailShow = false;
          });
          this.contract = res.data;
          this.existEle = res.data.existEle;
          this.existWater = res.data.existWater;
          this.form = {
            id: this.contract.id, //退租单id
            returnOrderStatus: this.contract.returnOrderStatus, //退租单状态
            contractId: this.contract.contractId, //合约id
            receiptId: this.contract.receiptId, //收款人id
            status: this.contract.returnOrderStatus, //退租单状态
            payType: this.contract.payType, //支付方式
            bankAccount: this.contract.bankAccount, //收款账号
            accountName: this.contract.accountName, //收款人姓名
            bankName: this.contract.bankName, //银行名称
            quitDate: this.contract.quitDate, //退租日期
            quitType: this.contract.quitType, //退租类型
            electricTotalUrl: this.contract.returnOrderImage
              ? this.contract.returnOrderImage.electricTotal
              : "", //电总图
            electricMaxUrl: this.contract.returnOrderImage
              ? this.contract.returnOrderImage.electricMax
              : "", //电峰图
            electricMinUrl: this.contract.returnOrderImage
              ? this.contract.returnOrderImage.electricMin
              : "", //电谷图
            electricTotal: this.contract.electricTotal, //电总
            electricMax: this.contract.electricMax, //电峰
            electricMin: this.contract.electricMin, //电谷
            waterUrl: this.contract.returnOrderImage
              ? this.contract.returnOrderImage.water
              : "", //水图
            water: this.contract.water, //水
            gasUrl: this.contract.returnOrderImage
              ? this.contract.returnOrderImage.gas
              : "", //燃气图
            gas: this.contract.gas, //燃气
            othersRemark: (this.contract.returnOrderImage || {}).remark, //备注
            othersUrl: this.contract.returnOrderImage
              ? this.contract.returnOrderImage.other
              : "", //其它
            receivableOrderItems: this.contract.receivableOrderItems
              ? this.contract.receivableOrderItems
              : [],
            payableOrderItems: this.contract.payableOrderItems
              ? this.contract.payableOrderItems
              : [],
            delivery: this.contract.returnOrderImage
              ? this.contract.returnOrderImage.delivery
              : "", //退租交接单
          };
          //图片
          this.electricTotalUrl = this.form.electricTotal
            ? [{ url: this.form.electricTotalUrl, isImage: true }]
            : []; //电总
          this.electricMaxUrl = this.form.electricMax
            ? [{ url: this.form.electricMaxUrl, isImage: true }]
            : []; //电峰
          this.electricMinUrl = this.form.electricMin
            ? [{ url: this.form.electricMinUrl, isImage: true }]
            : []; //电谷
          this.waterUrl = this.form.water
            ? [{ url: this.form.waterUrl, isImage: true }]
            : []; //水
          this.gasUrl = this.form.gas
            ? [{ url: this.form.gasUrl, isImage: true }]
            : []; //燃气
          let othersUrl = [];
          if (this.contract.returnOrderImage) {
            (this.contract.returnOrderImage.other || "")
              .split(";")
              .forEach((d) => {
                if (d) {
                  othersUrl.push({
                    url: d,
                    isImage: true,
                  });
                }
              });
            this.otherList = [...othersUrl];
          }
          this.getDateRange();
          this.getAccount(this.contract.customerId);
          //水电燃度数
          this.houseDegrees = {
            lastElectricMax: res.data.lastElectricMax / 1,
            lastElectricMin: res.data.lastElectricMin / 1,
            lastElectricTotal: res.data.lastElectricTotal / 1,
            lastGas: res.data.lastGas / 1,
            lastWater: res.data.lastWater / 1,
          };
          console.log(this.houseDegrees);
          return res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //第一步
    //资产详情
    lookAssets(assets) {
      this.asstesDetail = assets;
      this.showAssets = true;
    },
    next1() {
      this.active = 1;
    },
    //第二步
    //收款账号
    getAccount(customerId) {
      requestAccountSelect(customerId).then((res) => {
        if (res.data) {
          res.data.forEach((d) => {
            d.text =
              (d.payType == 3 || d.payType == 4
                ? d.bankName + " | " + d.bankBranchName
                : d.payTypeName) +
              " | " +
              d.accountName +
              " | " +
              d.bankAccount;
          });
        }
        this.accountList = res.data || [];
      });
    },
    onSearchCustomer() {
      if (!this.searchValueCustomer) return;
      this.searchLoad = true;
      this.customerList = [];
      let param = {
        payType: this.form.payType,
        info: this.searchValueCustomer,
      };
      requestReceiptList(param, this.contract.customerId).then((res) => {
        this.searchLoad = false;
        this.customerList = res.data;
      });
    },
    //带入搜出的收款人
    changeCustomer(item) {
      this.form.receiptId = item.id;
      this.form.bankAccount = item.bankAccount;
      this.form.accountName = item.accountName;
      this.form.bankName = item.bankName;
      this.showCustomer = false;
    },
    //搜索确认（带入自定义收款人）
    onConfirm() {
      this.form.receiptId = "";
      this.form.bankAccount = this.searchValueCustomer;
      this.form.accountName = "";
      this.form.bankName = "";
      this.showCustomer = false;
    },

    //修改退租类型
    quitTypeConfirm(item) {
      this.form.quitDate = "";
      this.form.quitType = item.value;
      this.showQuitType = false;
      this.$refs.form2.resetValidation("quitType");
      this.getDateRange();
    },
    //计算时间范围
    getDateRange() {
      switch (this.form.quitType) {
        case 1:
          //正常到期退
          this.startRangeDate =
            this.contract.endDate > this.timeBefore3
              ? new Date(this.contract.endDate.replace(/-/g, "/"))
              : new Date(this.timeBefore3.replace(/-/g, "/"));
          this.endRangeDate = this.createTime;
          break;
        case 3:
        //正常提前退
        case 2:
        case 4:
        case 6:
          //租客违约，公司违约，协商违约
          this.startRangeDate =
            this.contract.startDate > this.timeBefore3
              ? new Date(this.contract.startDate.replace(/-/g, "/"))
              : new Date(this.timeBefore3.replace(/-/g, "/"));
          this.endRangeDate = this.createTime;
          break;

        default:
          break;
      }
      console.log(formatDate(new Date(this.startRangeDate)));
      console.log(formatDate(new Date(this.endRangeDate)));
    },
    //获取七牛token
    getQiniuToken() {
      requestQiniuToken()
        .then((res) => {
          this.qiniuData.token = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //图片上传前校验，压缩
    beforeRead(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      const isLt8M = file.size / 1024 / 1024 < 8;
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isJPG && !isPNG) {
        this.$toast.fail("图片只能是 JPG/PNG 格式！");
        return false;
      }
      if (!isLt10M) {
        this.$toast.fail("图片大小不能超过 10MB!");
        return false;
      }
      this.qiniuData.key = Date.now() + file.name;
      return new Promise((resolve, reject) => {
        compressAccurately(file, 400).then((fileMin) => {
          let data = new FormData();
          data.append("token", this.qiniuData.token);
          data.append("key", this.qiniuData.key);
          data.append("file", fileMin);
          request({
            url: this.$store.state.qiniuUpload,
            method: "post",
            processData: false,
            headers: {
              "Content-Type": "multipart/form-data",
            },
            data: data,
          })
            .then((res) => {
              let newFile = fileMin;
              newFile.key = res.key;
              resolve(newFile);
            })
            .catch((err) => {
              console.log(err);
              reject(err);
            });
        });
      });
    },
    next2() {
      this.$refs.form2.validate().then((valid) => {
        this.active = 2;
        this.changeOrderItems();
      });
    },
    //第三步
    //获取事项下拉
    getMatter() {
      if (this.orderType) {
        requestExpensesReturnR().then((res) => {
          res.data.forEach((d) => {
            d.disabled = false;
          });
          this.matterList = res.data;
        });
      } else {
        requestExpensesReturnP().then((res) => {
          if (this.contract.tenantType == 2) {
            res.data.forEach((item, index) => {
              item.disabled = false;
              if (item.number == "WYJ" && this.form.quitType == 2) {
                item.disabled = true;
              }
            });
          }
          this.matterList = res.data;
        });
      }
    },
    //获取事项
    changeOrderItems() {
      // if (this.contract.status == "3") {
      //     return;
      // }
      let param = {
        contractId: this.form.contractId,
        quitDate: this.form.quitDate,
        quitType: this.form.quitType,
        electricMax: this.form.electricMax,
        electricMin: this.form.electricMin,
        electricTotal: this.form.electricTotal,
        water: this.form.water,
        gas: this.form.gas,
        id: this.form.id,
        status: this.form.status,
      };
    if (!this.existEle && !this.existWater) {
        if (
          !param.quitDate ||
          !param.quitType ||
          !param.electricMax ||
          !param.electricMin ||
          !param.electricTotal ||
          !param.water ||
          !param.gas
        ) {
          return;
        }
      } else {
        if (!param.quitDate || !param.quitType || !param.gas) {
          return;
        }
      }
        // if (
        //         !param.quitDate ||
        //         !param.quitType ||
        //         !param.electricMax ||
        //         !param.electricMin ||
        //         !param.electricTotal ||
        //         !param.water ||
        //         !param.gas ||
        //         this.form.returnOrderStatus == 3
        //     ) {
        //         return;
        //     }
      console.log(param);
      //清除接口请求的事项
      let receivableOrderItems = [];
      let receivIds = [];
      let payableOrderItems = [];
      let payIds = [];
      this.form.receivableOrderItems.forEach((e) => {
        if (e.readOnly && !e.orderItemId) {
          receivIds.push(e.matterId);
        } else {
          receivableOrderItems.push(e);
        }
      });
      this.form.payableOrderItems.forEach((e) => {
        if (e.readOnly && !e.orderItemId) {
          payIds.push(e.matterId);
        } else {
          payableOrderItems.push(e);
        }
      });
      this.form.receivableOrderItems = receivableOrderItems;
      this.form.payableOrderItems = payableOrderItems;
      this.receivIds = receivIds;
      this.payIds = payIds;
      requestOrderItems(param)
        .then((res) => {
          //应收
          res.data.receivableOrderItems.forEach((d) => {
            this.form.receivableOrderItems.push(d);
          });
          //应付
          res.data.payableOrderItems.forEach((d) => {
            this.form.payableOrderItems.push(d);
          });
          this.form.receivableOrderItems.sort((a, b) => {
            return a.readOnly - b.readOnly;
          });
          this.form.payableOrderItems.sort((a, b) => {
            return a.readOnly - b.readOnly;
          });
        })
        .catch((err) => {});
    },
    //添加事项
    orderConfirm(action, done) {
      if (action === "confirm") {
        this.$refs.orderItem
          .validate()
          .then((res) => {
            this.orderType
              ? this.form.receivableOrderItems.push(this.matter)
              : this.form.payableOrderItems.push(this.matter);
            done();
            this.matter = {
              matterId: "",
              matterName: "",
              amount: "",
              readOnly: 0,
              remark: "",
            };
          })
          .catch((err) => {
            done(false);
          });
      } else {
        this.matter = {
          matterId: "",
          matterName: "",
          amount: "",
          readOnly: 0,
          remark: "",
        };
        done();
      }
    },

    //保存
    async next3() {
      if (this.imgUp && (!this.existEle || !this.existWater)) {
        // 如果有智能水电表
        console.log(this.electricMaxUrl)
        this.form.electricMaxUrl = this.electricMaxUrl[0]?this.electricMaxUrl[0].url:'';
        this.form.electricMinUrl = this.electricMinUrl[0]?this.electricMinUrl[0].url:'';
        this.form.electricTotalUrl = this.electricTotalUrl[0]?this.electricTotalUrl[0].url:'';
        this.form.waterUrl = this.waterUrl[0]?this.waterUrl[0].url:'';
      }
      this.form.gasUrl = this.gasUrl[0].url;
      let otherList = [];
      this.otherList.forEach((d) => {
        otherList.push(d.url);
      });
      this.form.othersUrl = otherList.join(";");
      // if (!this.showWaterModel && !this.showElectronicModel) {
      //   let wData = await this.getHouseWaterExistIsRight();
      //   let eData = await this.getHouseElectronicExistIsRight();

      //   if (this.waterSubmit == 1) {
      //     this.$toast.fail(
      //       `当前合同所关联的${
      //         this.form.rentType > 1 ? "房源" : "房间"
      //       }【智能水表】设备绑定关系不正确，无法提交`
      //     );
      //     return false;
      //   }
      //   if (this.ElectronicSubmit == 1) {
      //     this.$toast.fail(
      //       `当前合同所关联的${
      //         this.form.rentType > 1 ? "房源" : "房间"
      //       }【智能电表】设备绑定关系不正确，无法提交`
      //     );
      //     return false;
      //   }
      // }

      this.saveLoad = true;
      requestReturnAdd(this.form)
        .then((res) => {
          this.$toast.success({
            message: "保存成功！",
            forbidClick: true,
            onClose: () => {
              this.$router.back();
              this.saveLoad = false;
            },
          });
        })
        .catch((err) => {
          this.saveLoad = false;
        });
    },
    formatDate(val) {
      return formatDate(val);
    },
    accSub(num1, num2) {
      return accSub(num1, num2);
    },
    accAdd(num1, num2) {
      if (num1 && num2) {
        return accAdd(num1, num2);
      } else {
        return;
      }
    },
    //正数或0，最多保留两位小数
    validNum0Decimal2(val) {
      return validNum0Decimal2(val);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
.field {
  padding: 0.26667rem 0.42667rem;
  background: #fff;
  font-size: 0.3rem;
  line-height: 0.64rem;
  color: #323232;
  text-align: left;
  border-top: 1px solid #ebedf0;
  border-bottom: 1px solid #ebedf0;
  .button-mini {
    width: 0.5rem;
    height: 0.5rem;
    line-height: 0.5rem;
    display: inline-block;
    text-align: center;
    border: 1px solid #a2a2a2;
    border-radius: 0.1rem;
    vertical-align: middle;
  }
}
.unit {
  display: flex;
  padding-right: 0.42rem;
  background: #fff;
  .van-field {
    width: 80%;
    flex: 1;
  }
  .after {
    flex: 0.1;
    padding: 0.26667rem 0;
    line-height: 0.64rem;
  }
}
.search {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  background-color: #fff;
  z-index: 99;
  overflow: scroll;
  .van-search {
    /deep/i {
      line-height: 0.84rem;
    }
    /deep/input {
      border: none;
    }
  }
}
.step {
  text-align: left;
}
.form1,
.form2,
.form3 {
  height: calc(100vh - 1.7rem);
  overflow: scroll;
}
.form1 {
  .title {
    background-color: #fff;
    text-align: left;
    padding-left: 0.2rem;
  }
  .assetsBody {
    display: flex;
    justify-content: flex-start;
    background-color: #fff;
    padding: 0.2rem 0;
    flex-wrap: wrap;
    > div {
      width: 28%;
      height: 0.8rem;
      line-height: 0.8rem;
      border: 1px solid $theme-color;
      color: $theme-color;
      text-align: center;
      margin: 0 2.5% 0.1rem;
    }
  }
}
.form2 {
  background-color: #fff;
  text-align: left;
  .field {
    position: relative;
  }
  .body {
    padding: 0.1rem;
    .van-uploader {
      // margin: 0.2rem;
      /deep/.van-uploader__preview-image {
        border: 1px solid #ebedf0;
      }
    }

    .picCard {
      display: inline-block;
      margin: 0.2rem 0.532rem;
      width: 2.2rem;
      .text {
        text-align: center;
        margin-bottom:0.2rem;
        .van-field {
          padding: 0;
          /deep/input {
            text-align: center;
          }
        }
      }
      .textBorder {
        /deep/.van-field__body {
          border: 1px solid $border-color;
          border-radius: 0.1rem;
          overflow: hidden;
        }
      }
      /deep/.van-field__error-message {
        text-align: center;
      }
    }
  }
  .box {
    width: 100%;
    height: 2.13333rem;
    border-bottom: 0.02667rem solid #ebedf0;
    padding: 1rem 0;
    text-align: center;
  }
  .body1 {
    padding: 0.3rem;
  }
}
.form3 {
  /deep/.van-tab {
    text-align: left;
    font-weight: 600;
    .van-tab__text {
      font-size: 0.4rem;
    }
  }
  .card {
    margin: 0.2rem 0;
    border-radius: 0.2rem;
    overflow: hidden;
  }
  .title {
    font-size: 0.4rem;
    text-align: left;
    padding: 0 0.4rem;
    font-weight: 600;
    background-color: #fff;
    line-height: 1.1rem;
    color: #fd7e2d;
    position: relative;
    .icon {
      position: absolute;
      right: 0.4rem;
    }
  }
  /deep/.van-tabs {
    font-size: 0.4rem;
    padding: 0 0.38rem;
    background-color: #fff;
  }
  .table {
    tr {
      td {
        text-align: center;
        line-height: 0.7rem;
      }
    }
    .head {
      font-weight: 600;
    }
  }
  .orderBody {
    padding: 0 0.4rem;
    // border: 2px dashed #dadada;
    margin: 0.1rem 0;
    border-radius: 0.2rem;
    background-color: #fff;
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
    .orderBody-head {
      padding: 0.2rem;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid $border-color;
      .line {
        width: 1px;
        height: 0.8rem;
        transform: translateY(0.05rem);
        background: #dadada;
      }
      .name {
      }
      .text {
        font-weight: bold;
        // color: $font-deep-gray;
      }
      p {
        padding: 0.1rem 0;
      }
    }
    .orderBody-body {
      display: flex;
      padding: 0.3rem 0;
      border-bottom: 1px solid $border-color;
      .name {
        flex: 1;
        text-align: left;
        .money {
          color: $fail-color;
        }
      }
      .success {
        color: $success-color;
      }
      .fail {
        color: $fail-color;
      }
      .pay {
        color: #fff;
        padding: 0.1rem 0.2rem;
        background: #fd7e2d;
        border-radius: 0.1rem;
      }
      .text {
        span {
          display: inline-block;
          width: 0.5rem;
        }
        i {
          font-size: 0.3rem;
        }
      }
    }
    .border-b {
      border: none !important;
    }
    .details {
      color: $font-deep-gray;
      padding: 0.2rem 0;
      > div {
        display: flex;
        padding: 0.1rem;
        .name {
          flex: 1;
          text-align: left;
        }
      }
    }
    .blod {
      font-weight: bold;
    }
  }
}
.btn {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  border-radius: 0.1rem;
  overflow: hidden;
  display: flex;
  /deep/.van-button {
    margin-left: -1px;
    border: none;
    border-radius: 0;
    flex: 1;
    &:not(:last-child)::after {
      height: 50%;
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      border-right: 0.02667rem solid #ebedf0;
      z-index: 99;
    }
  }
}
</style>
